module.exports = __webpack_public_path__ + "img/60c1ff158a6696.79962296.8178fb3c.png";